import { createFileRoute, redirect } from "@tanstack/react-router";

import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/")({
  head: () => pageHead("en", "home"),
  beforeLoad: () => {
    throw redirect({ to: "/$lang", params: { lang: "en" }, replace: true });
  },
});
